"use client";

import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionList,
  Title,
} from "@tremor/react";
import translation from "./locale/index.json";
import getLanguage from "@/app/utils/getlanguage";
import { useLocale } from "@/app/context/use-locale";

export interface IFaqObject {
  "@type": string;
  name: string;
  acceptedAnswer: {
    "@type": string;
    text: string;
  };
}

export interface IFaq {
  LdObjectFaq: IFaqObject[];
  defaultOpen?: boolean;
}

export default function FaqCreator(props: IFaq) {
  const { LdObjectFaq, defaultOpen } = props;
  const locale = useLocale();
  const content = getLanguage(translation, locale);

  return (
    <>
      <Title className="mb-2 mt-2">{content.faq}</Title>
      <AccordionList>
        {LdObjectFaq?.map((item, index) => {
          return (
            <Accordion
              defaultOpen={
                defaultOpen === undefined || defaultOpen ? true : false
              }
              key={index}
            >
              <AccordionHeader className="font-medium text-tremor-content-strong dark:text-dark-tremor-content-strong">
                {item.name}
              </AccordionHeader>
              <AccordionBody className="text-gray-600 leading-6">
                {item.acceptedAnswer.text}
              </AccordionBody>
            </Accordion>
          );
        })}
      </AccordionList>
    </>
  );
}
